module.exports = __webpack_public_path__ + "img/How-to-Bleach-Knots-on-Wig.dd3415f9.png";